export default __webpack_public_path__ + "static/media/prize.5347ca21.png";